import React, { useEffect, useState } from "react";
import axios from "axios";
import endPoint from "../websitecomponents/redux/EndPoint/endpoint";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ReSellerEditProfile = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    bankDetails: {
      holderName: "",
      accountNumber: "",
      ifscCode: "",
      bankName: "",
      upiId: "",
    },
  });

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const token = localStorage.getItem("ResellerTokenData");
    if (!token) return;

    try {
      setLoading(true);
      const res = await axios.get(endPoint.ReSellerProfile, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const r = res.data?.reseller;

      setFormData({
        fullName: r?.fullName || "",
        email: r?.email || "",
        phone: r?.phone || "",
        bankDetails: {
          holderName: r?.bankDetails?.holderName || "",
          accountNumber: r?.bankDetails?.accountNumber || "",
          ifscCode: r?.bankDetails?.ifscCode || "",
          bankName: r?.bankDetails?.bankName || "",
          upiId: r?.bankDetails?.upiId || "",
        },
      });
    } catch {
      toast.error("Failed to load profile");
    } finally {
      setLoading(false);
    }
  };

  // 🔥 SAME LOGIC AS SELLER
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (
      ["holderName", "accountNumber", "ifscCode", "bankName", "upiId"].includes(
        name,
      )
    ) {
      setFormData((prev) => ({
        ...prev,
        bankDetails: {
          ...prev.bankDetails,
          [name]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("ResellerTokenData");
    if (!token) return;

    const payload = {
      fullName: formData.fullName,
      phone: formData.phone,
      bankDetails: {
        holderName: formData.bankDetails?.holderName || "",
        accountNumber: formData.bankDetails?.accountNumber || "",
        ifscCode: formData.bankDetails?.ifscCode || "",
        bankName: formData.bankDetails?.bankName || "",
        upiId: formData.bankDetails?.upiId || "",
      },
    };

    try {
      setLoading(true);

      await axios.patch(endPoint.ReSellerUpdateProfile, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Profile updated successfully");
      navigate("/reseller/profile");
    } catch {
      toast.error("Profile update failed");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p className="p-6">Loading...</p>;

  return (
    <div className="max-w-6xl mx-auto px-4 py-6">
      <h2 className="text-xl font-semibold mb-6">Edit Reseller Profile</h2>

      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6"
      >
        {/* BASIC DETAILS */}
        <Input
          label="Full Name"
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
        />

        <Input label="Email" name="email" value={formData.email} disabled />

        <Input
          label="Phone Number"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />

        {/* BANK DETAILS */}
        <h3 className="md:col-span-2 text-lg font-semibold mt-6">
          Bank Details
        </h3>

        <Input
          label="Account Holder Name"
          name="holderName"
          value={formData.bankDetails?.holderName}
          onChange={handleChange}
        />

        <Input
          label="Account Number"
          name="accountNumber"
          value={formData.bankDetails?.accountNumber}
          onChange={handleChange}
        />

        <Input
          label="IFSC Code"
          name="ifscCode"
          value={formData.bankDetails?.ifscCode}
          onChange={handleChange}
        />

        <Input
          label="Bank Name"
          name="bankName"
          value={formData.bankDetails?.bankName}
          onChange={handleChange}
        />

        {/* ACTIONS */}
        <div className="md:col-span-2 flex gap-4 mt-6">
          <button
            type="submit"
            className="px-6 py-3 bg-orange-600 text-white rounded-lg"
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>

          <button
            type="button"
            onClick={() => navigate(-1)}
            className="px-6 py-3 border rounded-lg"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

/* 🔹 SAME INPUT AS SELLER */
const Input = ({ label, name, value, onChange, disabled = false }) => (
  <div>
    <p className="text-sm text-gray-500 mb-1">{label}</p>
    <input
      type="text"
      name={name}
      value={value || ""}
      onChange={onChange}
      disabled={disabled}
      className="w-full border-b border-gray-300 py-2 focus:outline-none focus:border-blue-600"
    />
  </div>
);

export default ReSellerEditProfile;
